/* global axios */
import ApiClient from './ApiClient';

class ProvetAPI extends ApiClient {
  constructor() {
    super('provet', { accountScoped: true });
  }

  clientPreview({ clientId } = {}) {
    return axios.get(`${this.url}/client_preview`, {
      params: { client_id: clientId },
    });
  }

  sync({ clientId } = {}) {
    return axios.post(`${this.url}/sync`, {
      client_id: clientId,
    });
  }

  syncCcMembership() {
    return axios.post(`${this.url}/sync_cc_membership`);
  }

  addClientPhone({ clientId, phone }) {
    return axios.post(`${this.url}/add_client_phone`, {
      client_id: clientId,
      phone,
    });
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  sendReviewRequests({ date, startedFrom, startedUntil } = {}) {
    return axios.post(`${this.url}/send_review_requests`, {
      date,
      started_from: startedFrom,
      started_until: startedUntil,
    });
  }

  updateSettings({ aiConversationHelper, reviewRequestsEnabled } = {}) {
    const payload = {};
    if (aiConversationHelper !== undefined) {
      payload.ai_conversation_helper = aiConversationHelper;
    }
    if (reviewRequestsEnabled !== undefined) {
      payload.review_requests_enabled = reviewRequestsEnabled;
    }
    return axios.patch(`${this.url}/settings`, payload);
  }

  // Working Schedules methods
  getWorkingSchedules(params = {}) {
    return axios.get(`${this.baseUrl()}/working_schedules`, { params });
  }

  getWorkingSchedule(id) {
    return axios.get(`${this.baseUrl()}/working_schedules/${id}`);
  }

  createWorkingSchedule(data) {
    return axios.post(`${this.baseUrl()}/working_schedules`, data);
  }

  updateWorkingSchedule(id, data) {
    return axios.patch(`${this.baseUrl()}/working_schedules/${id}`, data);
  }

  deleteWorkingSchedule(id) {
    return axios.delete(`${this.baseUrl()}/working_schedules/${id}`);
  }

  testSchedule(date, time) {
    const params = {};
    if (date) {
      params.date = date;
    }
    if (time) {
      params.time = time;
    }
    return axios.get(`${this.baseUrl()}/working_schedules/is_out_of_hours`, { params });
  }
}

export default new ProvetAPI();

